// import React, { useEffect, useState } from "react";
// import {
//   Button,
//   Form,
//   Table,
//   Pagination,
//   Spinner,
//   Modal,
// } from "react-bootstrap";
// import axios from "axios";
// import * as XLSX from "xlsx";
// import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";
// import { FaEdit } from "react-icons/fa";

// const API_URL = process.env.REACT_APP_API_URL;

// function AccountStatusList() {
//   const [visits, setVisits] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [searchName, setSearchName] = useState("");
//   const [searchAccount, setSearchAccount] = useState("");
//   const [submittedSearchName, setSubmittedSearchName] = useState("");
//   const [submittedSearchAccount, setSubmittedSearchAccount] = useState("");
//   const [exporting, setExporting] = useState(false);
//   const [selectedStatus, setSelectedStatus] = useState("");

//   // Edit state
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [editingVisit, setEditingVisit] = useState(null);
//   const [editFormData, setEditFormData] = useState({
//     account_holder_name: "",
//     bank_name: "",
//     account_number: "",
//     ifsc_code: "",
//     status: "",
//     bank_branch_name: "",
//   });
//   const [updating, setUpdating] = useState(false);

//   const getAuthToken = () => localStorage.getItem("token");

//   const [isFilterActive, setIsFilterActive] = useState(false);
//   const handleToggle = () => setIsFilterActive(!isFilterActive);

//   const fetchVisits = async (
//     page = 1,
//     name = "",
//     account = "",
//     status = "",
//     mobile = "",
//   ) => {
//     setLoading(true);
//     const token = getAuthToken();
//     try {
//       const response = await axios.get(
//         `${API_URL}/bank-account-list-by-status?page=${page}&limit=10&status=${status}&name=${name}&account_number=${account}&mobile=${mobile}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         },
//       );
//       const result = response.data;
//       if (result.success === "1") {
//         setVisits(result.data);
//         setTotalPages(result.totalPages || 1);
//         setCurrentPage(result.page || page);
//       } else {
//         setError(result.message || "Failed to fetch Bank list.");
//         setVisits([]);
//         setTotalPages(1);
//       }
//     } catch (err) {
//       setError("Failed to fetch Bank list.");
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchVisits(
//       currentPage,
//       submittedSearchName,
//       submittedSearchAccount,
//       selectedStatus,
//     );
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [
//     currentPage,
//     submittedSearchName,
//     submittedSearchAccount,
//     selectedStatus,
//   ]);

//   // ---------------- EDIT ----------------
//   const handleEditClick = (visit) => {
//     setEditingVisit(visit);
//     setEditFormData({
//       account_holder_name: visit.account_holder_name || "",
//       bank_name: visit.bank_name || "",
//       account_number: visit.account_number || "",
//       ifsc_code: visit.ifsc_code || "",
//       status: visit.status || "",
//       bank_branch_name: visit.bank_branch_name || "",
//     });
//     setShowEditModal(true);
//   };

//   const handleEditFormChange = (e) => {
//     const { name, value } = e.target;
//     setEditFormData({ ...editFormData, [name]: value });
//   };

//   const handleUpdate = async () => {
//     if (!editingVisit) return;
//     setUpdating(true);
//     const token = getAuthToken();

//     try {
//       const payload = {
//         id: editingVisit.id,
//         account_holder_name: editFormData.account_holder_name,
//         bank_name: editFormData.bank_name,
//         account_number: editFormData.account_number,
//         ifsc_code: editFormData.ifsc_code,
//         status: editFormData.status,
//         bank_branch_name: editFormData.bank_branch_name,
//       };

//       const response = await axios.post(
//         `${API_URL}/update-bank-details`,
//         payload,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         },
//       );

//       if (response.data.success === "1") {
//         fetchVisits(
//           currentPage,
//           submittedSearchName,
//           submittedSearchAccount,
//           selectedStatus,
//         );
//         setShowEditModal(false);
//         setEditingVisit(null);
//       } else {
//         alert(
//           `Update failed: ${response.data.message || "Failed to update bank details"}`,
//         );
//       }
//     } catch (err) {
//       console.error("Update error:", err);
//       alert("Error: Failed to update bank details");
//     } finally {
//       setUpdating(false);
//     }
//   };

//   // ---------------- EXPORT ----------------
//   const exportAllToExcel = async () => {
//     setExporting(true);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         alert("Authentication Error: Please log in.");
//         return;
//       }

//       const url = `${API_URL}/bank-account-list-by-status`;
//       const response = await fetch(url, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         alert(`Error: ${errorData.message || "Failed to fetch data."}`);
//         return;
//       }

//       const data = await response.json();
//       const allAssociates = data.data || [];
//       const worksheet = XLSX.utils.json_to_sheet(
//         allAssociates.map((associate, idx) => ({
//           "SL No.": idx + 1,
//           "Account Holder Name": associate.account_holder_name,
//           "Bank Name": associate.bank_name,
//           "Account Number": associate.account_number,
//           IFSC: associate.ifsc_code,
//           Name: associate.username,
//           Mobile: associate.mobile,
//           Status: associate.status,
//         })),
//       );

//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Success-Reject");
//       XLSX.writeFile(
//         workbook,
//         `All_Success-Reject_${new Date().toISOString().split("T")[0]}.xlsx`,
//       );
//     } catch (err) {
//       console.error("Export error:", err);
//       alert("Error: Failed to export Success-Reject.");
//     } finally {
//       setExporting(false);
//     }
//   };

//   const handlePageChange = (pageNumber) => {
//     if (pageNumber >= 1 && pageNumber <= totalPages) {
//       setCurrentPage(pageNumber);
//     }
//   };

//   const handleSearchSubmit = (e) => {
//     e.preventDefault();
//     setSubmittedSearchName(searchName);
//     setSubmittedSearchAccount(searchAccount);
//     setCurrentPage(1);
//   };

//   const handleStatusChange = (e) => {
//     const newStatus = e.target.value;
//     setSelectedStatus(newStatus);
//     setSearchName("");
//     setSearchAccount("");
//     setSubmittedSearchName("");
//     setSubmittedSearchAccount("");
//     setCurrentPage(1);
//   };

//   // ---------------- LOADING ----------------
//   if (loading) {
//     return (
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         <Spinner animation="border" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </Spinner>
//       </div>
//     );
//   }

//   // ---------------- ERROR ----------------
//   if (error) {
//     return (
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//         }}
//       >
//         <div className="alert alert-danger">{error}</div>
//       </div>
//     );
//   }

//   // ---------------- MAIN ----------------
//   return (
//     <>
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//           fontFamily: "'Poppins', 'DM Sans', sans-serif",
//         }}
//       >
//         <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//           {/* 🎯 HEADER CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               padding: "20px 24px",
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               marginBottom: "20px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div
//               style={{
//                 width: "52px",
//                 height: "52px",
//                 borderRadius: "14px",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#ffffff",
//                 fontSize: "24px",
//                 boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                 flexShrink: 0,
//               }}
//             >
//               ✅
//             </div>
//             <div style={{ flex: 1, minWidth: "200px" }}>
//               <h1
//                 style={{
//                   margin: 0,
//                   fontSize: "24px",
//                   fontWeight: "800",
//                   color: "#1e3a5f",
//                   letterSpacing: "-0.5px",
//                 }}
//               >
//                 Success / Reject List
//               </h1>
//               <p
//                 style={{
//                   margin: "2px 0 0",
//                   fontSize: "13px",
//                   color: "#64748b",
//                   fontWeight: "500",
//                 }}
//               >
//                 Manage approved and rejected bank accounts
//               </p>
//             </div>

//             <div className="d-flex gap-2 flex-wrap">
//               <button
//                 className="btn btn-primary d-flex align-items-center gap-2"
//                 onClick={exportAllToExcel}
//                 disabled={exporting}
//               >
//                 {exporting ? (
//                   <>
//                     <span
//                       className="spinner-border spinner-border-sm"
//                       role="status"
//                       aria-hidden="true"
//                     ></span>
//                     Exporting...
//                   </>
//                 ) : (
//                   "Download"
//                 )}
//               </button>

//               <button
//                 className={`filter-toggle-btn btn ${
//                   isFilterActive ? "active" : ""
//                 }`}
//                 onClick={handleToggle}
//                 style={{
//                   width: "44px",
//                   height: "44px",
//                   borderRadius: "12px",
//                   border: "1.5px solid #e2e8f0",
//                   background: isFilterActive ? "#1e5799" : "#ffffff",
//                   color: isFilterActive ? "#ffffff" : "#1e3a5f",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   fontSize: "20px",
//                   cursor: "pointer",
//                   transition: "all 0.25s ease",
//                   boxShadow: isFilterActive
//                     ? "0 8px 20px rgba(30, 87, 153, 0.3)"
//                     : "none",
//                 }}
//                 title={isFilterActive ? "Hide Filters" : "Show Filters"}
//               >
//                 {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
//               </button>
//             </div>
//           </div>

//           {/* 🎯 MAIN CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 height: "5px",
//                 background:
//                   "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//               }}
//             />

//             <div style={{ padding: "30px" }}>
//               {/* FILTER PANEL */}
//               {isFilterActive && (
//                 <div
//                   style={{
//                     background: "#f8fafc",
//                     border: "1.5px dashed #cbd5e1",
//                     borderRadius: "12px",
//                     padding: "20px",
//                     marginBottom: "24px",
//                   }}
//                 >
//                   <div className="d-flex gap-2 flex-wrap-mobile">
//                     <Form.Group
//                       className="w-100 text-dark"
//                       controlId="selectStatus"
//                     >
//                       <Form.Select
//                         className="text-dark"
//                         value={selectedStatus}
//                         onChange={handleStatusChange}
//                       >
//                         <option value="">All</option>
//                         <option value="success">Success</option>
//                         <option value="reject">Reject</option>
//                       </Form.Select>
//                     </Form.Group>

//                     <Form
//                       className="d-flex flex-wrap-mobile gap-2 w-100"
//                       onSubmit={handleSearchSubmit}
//                     >
//                       <Form.Group className="w-100" controlId="searchName">
//                         <Form.Control
//                           type="text"
//                           placeholder="Search by Name"
//                           value={searchName}
//                           onChange={(e) => setSearchName(e.target.value)}
//                         />
//                       </Form.Group>
//                       <Form.Group className="w-100" controlId="searchAccount">
//                         <Form.Control
//                           type="text"
//                           placeholder="Search by Account"
//                           value={searchAccount}
//                           onChange={(e) => setSearchAccount(e.target.value)}
//                         />
//                       </Form.Group>
//                       <Button variant="primary" type="submit">
//                         Search
//                       </Button>
//                     </Form>
//                   </div>
//                 </div>
//               )}

//               {/* TABLE */}
//               <Table striped bordered hover responsive>
//                 <thead>
//                   <tr>
//                     <th>#</th>
//                     <th>Name</th>
//                     <th>Mobile</th>
//                     <th>A/C Name</th>
//                     <th>Bank</th>
//                     <th>Branch Name</th>
//                     <th>A/C Number</th>
//                     <th>IFSC Code</th>
//                     <th>Status</th>
//                     <th>Date</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {visits.length > 0 ? (
//                     visits.map((visit, index) => (
//                       <tr key={visit.id}>
//                         <td>{(currentPage - 1) * 10 + index + 1}</td>
//                         <td>
//                           {visit.username
//                             ? visit.username.charAt(0).toUpperCase() +
//                               visit.username.slice(1).toLowerCase()
//                             : ""}
//                         </td>
//                         <td>{visit.mobile}</td>
//                         <td>
//                           {visit.account_holder_name
//                             ? visit.account_holder_name
//                                 .charAt(0)
//                                 .toUpperCase() +
//                               visit.account_holder_name
//                                 .slice(1)
//                                 .toLowerCase()
//                             : ""}
//                         </td>
//                         <td>
//                           {visit.bank_name
//                             ? visit.bank_name.charAt(0).toUpperCase() +
//                               visit.bank_name.slice(1).toLowerCase()
//                             : ""}
//                         </td>
//                         <td>{visit.bank_branch_name || "NA"}</td>
//                         <td>{visit.account_number}</td>
//                         <td>{visit.ifsc_code}</td>
//                         <td
//                           style={{
//                             color:
//                               visit.status === "success" ? "green" : "red",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {visit.status.charAt(0).toUpperCase() +
//                             visit.status.slice(1)}
//                         </td>
//                         <td>
//                           {new Date(visit.created_at)
//                             .toLocaleDateString("en-GB")
//                             .replace(/\//g, "-")}
//                         </td>
//                         <td>
//                           {visit.status === "success" && (
//                             <Button
//                               variant="primary"
//                               size="sm"
//                               className="edit-btn-hover d-flex align-items-center gap-1"
//                               onClick={() => handleEditClick(visit)}
//                             >
//                               <FaEdit className="edit-icon-hover" /> Edit
//                             </Button>
//                           )}
//                           {visit.status === "reject" && (
//                             <span className="text-muted">Not Allowed</span>
//                           )}
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan="11" className="text-center">
//                         No accounts found with status "{selectedStatus}".
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </Table>

//               {/* PAGINATION */}
//               <div className="d-flex justify-content-end mt-3">
//                 <Pagination>
//                   <Pagination.Prev
//                     onClick={() => handlePageChange(currentPage - 1)}
//                     disabled={currentPage === 1}
//                   />
//                   {[...Array(totalPages)].map((_, index) => (
//                     <Pagination.Item
//                       key={index + 1}
//                       active={index + 1 === currentPage}
//                       onClick={() => handlePageChange(index + 1)}
//                     >
//                       {index + 1}
//                     </Pagination.Item>
//                   ))}
//                   <Pagination.Next
//                     onClick={() => handlePageChange(currentPage + 1)}
//                     disabled={currentPage === totalPages}
//                   />
//                 </Pagination>
//               </div>
//             </div>
//           </div>

//           {/* Footer Copyright */}
//           <p
//             style={{
//               textAlign: "center",
//               color: "#94a3b8",
//               fontSize: "12.5px",
//               marginTop: "24px",
//               fontWeight: "500",
//             }}
//           >
//             © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
//             Rights Reserved.
//           </p>
//         </div>
//       </div>

//       {/* 🎯 EDIT MODAL */}
//       <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Update Bank Details</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {editingVisit && (
//             <Form>
//               <div className="row">
//                 <div className="col-md-6">
//                   <Form.Group className="mb-3">
//                     <Form.Label>Account Holder Name</Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="account_holder_name"
//                       value={editFormData.account_holder_name}
//                       onChange={handleEditFormChange}
//                     />
//                   </Form.Group>

//                   <Form.Group className="mb-3">
//                     <Form.Label>Bank Name</Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="bank_name"
//                       value={editFormData.bank_name}
//                       onChange={handleEditFormChange}
//                     />
//                   </Form.Group>

//                   <Form.Group className="mb-3">
//                     <Form.Label>Account Number</Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="account_number"
//                       value={editFormData.account_number}
//                       onChange={handleEditFormChange}
//                     />
//                   </Form.Group>
//                 </div>

//                 <div className="col-md-6">
//                   <Form.Group className="mb-3">
//                     <Form.Label>IFSC Code</Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="ifsc_code"
//                       value={editFormData.ifsc_code}
//                       onChange={handleEditFormChange}
//                     />
//                   </Form.Group>

//                   <Form.Group className="mb-3">
//                     <Form.Label>Branch Name</Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="bank_branch_name"
//                       value={editFormData.bank_branch_name}
//                       onChange={handleEditFormChange}
//                     />
//                   </Form.Group>
//                 </div>
//               </div>
//             </Form>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="danger" onClick={() => setShowEditModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleUpdate} disabled={updating}>
//             {updating ? (
//               <>
//                 <Spinner animation="border" size="sm" className="me-2" />
//                 Updating...
//               </>
//             ) : (
//               "Update"
//             )}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// }

// export default AccountStatusList;
import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import axios from "axios";
import * as XLSX from "xlsx";
import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";
import { FaEdit, FaDownload } from "react-icons/fa";
import Swal from "sweetalert2";

const API_URL = process.env.REACT_APP_API_URL;
const LIMIT = 10;

function AccountStatusList() {
  const [visits, setVisits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [searchName, setSearchName] = useState("");
  const [searchAccount, setSearchAccount] = useState("");
  const [submittedSearchName, setSubmittedSearchName] = useState("");
  const [submittedSearchAccount, setSubmittedSearchAccount] = useState("");
  const [exporting, setExporting] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [updating, setUpdating] = useState(false);

  // Edit state
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingVisit, setEditingVisit] = useState(null);
  const [editFormData, setEditFormData] = useState({
    account_holder_name: "",
    bank_name: "",
    account_number: "",
    ifsc_code: "",
    status: "",
    bank_branch_name: "",
  });

  const getAuthToken = () => localStorage.getItem("token");

  const handleToggle = () => setIsFilterActive(!isFilterActive);

  // ═══════════════════════════════════════════
  // 🔹 FETCH VISITS (Server-Side Pagination)
  // ═══════════════════════════════════════════
  const fetchVisits = async (
    page = 1,
    name = "",
    account = "",
    status = "",
    mobile = ""
  ) => {
    setLoading(true);
    setError(null);
    const token = getAuthToken();
    try {
      const response = await axios.get(
        `${API_URL}/bank-account-list-by-status?page=${page}&limit=${LIMIT}&status=${status}&name=${name}&account_number=${account}&mobile=${mobile}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const result = response.data;
      if (result.success === "1") {
        setVisits(result.data || []);

        const pages = Number(result.totalPages) || 1;
        const total = Number(result.total) || (result.data?.length || 0);

        setTotalPages(pages);
        setTotalItems(total);
        setCurrentPage(Number(result.page) || Number(page));
      } else {
        setError(result.message || "Failed to fetch Bank list.");
        setVisits([]);
        setTotalPages(1);
        setTotalItems(0);
      }
    } catch (err) {
      setError("Failed to fetch Bank list.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVisits(
      currentPage,
      submittedSearchName,
      submittedSearchAccount,
      selectedStatus
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, submittedSearchName, submittedSearchAccount, selectedStatus]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  // ═══════════════════════════════════════════
  // 🔹 SEARCH / FILTER
  // ═══════════════════════════════════════════
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setSubmittedSearchName(searchName);
    setSubmittedSearchAccount(searchAccount);
    setCurrentPage(1);
  };

  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
    setSearchName("");
    setSearchAccount("");
    setSubmittedSearchName("");
    setSubmittedSearchAccount("");
    setCurrentPage(1);
  };

  const handleClearFilters = () => {
    setSelectedStatus("");
    setSearchName("");
    setSearchAccount("");
    setSubmittedSearchName("");
    setSubmittedSearchAccount("");
    setCurrentPage(1);
  };

  // ═══════════════════════════════════════════
  // 🔹 EDIT
  // ═══════════════════════════════════════════
  const handleEditClick = (visit) => {
    setEditingVisit(visit);
    setEditFormData({
      account_holder_name: visit.account_holder_name || "",
      bank_name: visit.bank_name || "",
      account_number: visit.account_number || "",
      ifsc_code: visit.ifsc_code || "",
      status: visit.status || "",
      bank_branch_name: visit.bank_branch_name || "",
    });
    setShowEditModal(true);
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async () => {
    if (!editingVisit) return;
    setUpdating(true);
    const token = getAuthToken();

    try {
      const payload = {
        id: editingVisit.id,
        account_holder_name: editFormData.account_holder_name,
        bank_name: editFormData.bank_name,
        account_number: editFormData.account_number,
        ifsc_code: editFormData.ifsc_code,
        status: editFormData.status,
        bank_branch_name: editFormData.bank_branch_name,
      };

      const response = await axios.post(
        `${API_URL}/update-bank-details`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success === "1") {
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: "Bank details updated successfully.",
          timer: 1600,
          showConfirmButton: false,
        });
        fetchVisits(
          currentPage,
          submittedSearchName,
          submittedSearchAccount,
          selectedStatus
        );
        setShowEditModal(false);
        setEditingVisit(null);
      } else {
        Swal.fire(
          "Error",
          response.data.message || "Failed to update bank details",
          "error"
        );
      }
    } catch (err) {
      console.error("Update error:", err);
      Swal.fire("Error", "Failed to update bank details", "error");
    } finally {
      setUpdating(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 EXPORT
  // ═══════════════════════════════════════════
  const exportAllToExcel = async () => {
    setExporting(true);
    try {
      const token = getAuthToken();
      if (!token) {
        Swal.fire("Error", "Please log in.", "error");
        return;
      }

      const response = await fetch(`${API_URL}/bank-account-list-by-status`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        Swal.fire("Error", errorData.message || "Failed to fetch data.", "error");
        return;
      }

      const data = await response.json();
      const allAssociates = data.data || [];
      const worksheet = XLSX.utils.json_to_sheet(
        allAssociates.map((associate, idx) => ({
          "SL No.": idx + 1,
          "Account Holder Name": associate.account_holder_name,
          "Bank Name": associate.bank_name,
          "Account Number": associate.account_number,
          IFSC: associate.ifsc_code,
          Name: associate.username,
          Mobile: associate.mobile,
          Status: associate.status,
        }))
      );

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Success-Reject");
      XLSX.writeFile(
        workbook,
        `All_Success-Reject_${new Date().toISOString().split("T")[0]}.xlsx`
      );
    } catch (err) {
      console.error("Export error:", err);
      Swal.fire("Error", "Failed to export data.", "error");
    } finally {
      setExporting(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 PAGINATION PAGES
  // ═══════════════════════════════════════════
  const getPageNumbers = () => {
    const pages = [];
    const showEllipsis = totalPages > 7;

    pages.push(1);
    if (showEllipsis && currentPage > 4) pages.push("left-ellipsis");

    const start = Math.max(2, currentPage - 2);
    const end = Math.min(totalPages - 1, currentPage + 2);

    for (let i = start; i <= end; i++) pages.push(i);

    if (showEllipsis && currentPage < totalPages - 3) pages.push("right-ellipsis");
    if (totalPages > 1) pages.push(totalPages);

    return pages;
  };

  // ═══════════════════════════════════════════
  // 🔹 LOADING
  // ═══════════════════════════════════════════
  if (loading) {
    return (
      <div
        style={{
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        }}
      >
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "4px solid #e2e8f0",
            borderTop: "4px solid #1e5799",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <style>{`@keyframes spin { from {transform:rotate(0deg);} to {transform:rotate(360deg);} }`}</style>
      </div>
    );
  }

  // ═══════════════════════════════════════════
  // 🔹 ERROR
  // ═══════════════════════════════════════════
  if (error) {
    return (
      <div
        style={{
          minHeight: "80vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "30px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            background: "#feeaeb",
            border: "1.5px solid #fecaca",
            color: "#991b1b",
            borderRadius: "12px",
            padding: "20px 24px",
            fontWeight: "600",
            fontSize: "14px",
            display: "flex",
            gap: "16px",
            alignItems: "center",
          }}
        >
          <span>⚠️ {error}</span>
          <button
            onClick={() => fetchVisits(1)}
            style={{
              padding: "8px 18px",
              borderRadius: "8px",
              border: "none",
              background: "#dc2626",
              color: "#ffffff",
              fontWeight: "700",
              fontSize: "12px",
              cursor: "pointer",
            }}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  // ═══════════════════════════════════════════
  // 🎨 UI RENDER
  // ═══════════════════════════════════════════
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        padding: "24px",
        fontFamily: "'Poppins', 'DM Sans', sans-serif",
      }}
    >
      <div style={{ maxWidth: "1500px", margin: "0 auto" }}>
        <div
          style={{
            background: "#ffffff",
            borderRadius: "20px",
            boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
            border: "1.5px solid #e2e8f0",
            overflow: "hidden",
          }}
        >
          {/* Top Gradient */}
          <div
            style={{
              height: "5px",
              background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
            }}
          />

          {/* Header */}
          <div
            style={{
              padding: "24px 30px",
              background: "linear-gradient(135deg, #ffffff, #f8fafc)",
              borderBottom: "1.5px solid #e2e8f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "14px",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  fontSize: "22px",
                  boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                  flexShrink: 0,
                }}
              >
                ✅
              </div>
              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "22px",
                    fontWeight: "800",
                    color: "#1e3a5f",
                  }}
                >
                  Success / Reject List
                </h2>
                <p
                  style={{
                    margin: "2px 0 0",
                    fontSize: "12.5px",
                    color: "#64748b",
                    fontWeight: "500",
                  }}
                >
                  Manage approved and rejected bank accounts ({totalItems} total)
                </p>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexWrap: "wrap",
              }}
            >
              <button
                onClick={exportAllToExcel}
                disabled={exporting}
                style={{
                  padding: "10px 18px",
                  borderRadius: "10px",
                  border: "none",
                  background: exporting
                    ? "#cbd5e1"
                    : "linear-gradient(135deg, #059669, #047857)",
                  color: "#ffffff",
                  fontSize: "13px",
                  fontWeight: "700",
                  cursor: exporting ? "not-allowed" : "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow: exporting
                    ? "none"
                    : "0 6px 18px rgba(5, 150, 105, 0.3)",
                }}
              >
                <FaDownload /> {exporting ? "Exporting..." : "Download"}
              </button>

              <button
                onClick={handleToggle}
                style={{
                  width: "42px",
                  height: "42px",
                  borderRadius: "10px",
                  border: isFilterActive ? "none" : "1.5px solid #e2e8f0",
                  background: isFilterActive
                    ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                    : "#ffffff",
                  color: isFilterActive ? "#ffffff" : "#1e5799",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "18px",
                  cursor: "pointer",
                  boxShadow: isFilterActive
                    ? "0 6px 18px rgba(30, 87, 153, 0.3)"
                    : "none",
                }}
                title="Toggle Filters"
              >
                {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
              </button>
            </div>
          </div>

          {/* Body */}
          <div style={{ padding: "24px 30px" }}>
            {/* Filter Panel */}
            {isFilterActive && (
              <div
                style={{
                  background: "#f8fafc",
                  borderRadius: "14px",
                  padding: "18px",
                  marginBottom: "24px",
                  border: "1.5px solid #e2e8f0",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    flexWrap: "wrap",
                    alignItems: "flex-end",
                  }}
                >
                  <div style={{ flex: 1, minWidth: "160px" }}>
                    <label style={labelStyle}>Status</label>
                    <select
                      value={selectedStatus}
                      onChange={handleStatusChange}
                      style={inputStyle}
                    >
                      <option value="">All Status</option>
                      <option value="success">✅ Success</option>
                      <option value="reject">⛔ Reject</option>
                    </select>
                  </div>

                  <div style={{ flex: 1, minWidth: "180px" }}>
                    <label style={labelStyle}>Name</label>
                    <input
                      type="text"
                      placeholder="Search by Name"
                      value={searchName}
                      onChange={(e) => setSearchName(e.target.value)}
                      style={inputStyle}
                    />
                  </div>

                  <div style={{ flex: 1, minWidth: "180px" }}>
                    <label style={labelStyle}>Account Number</label>
                    <input
                      type="text"
                      placeholder="Search by Account"
                      value={searchAccount}
                      onChange={(e) => setSearchAccount(e.target.value)}
                      style={inputStyle}
                    />
                  </div>

                  <div style={{ display: "flex", gap: "8px" }}>
                    <button
                      onClick={handleSearchSubmit}
                      style={{
                        padding: "10px 22px",
                        borderRadius: "10px",
                        border: "none",
                        background:
                          "linear-gradient(135deg, #1e5799, #2b6cb0)",
                        color: "#ffffff",
                        fontWeight: "700",
                        cursor: "pointer",
                        height: "42px",
                      }}
                    >
                      Search
                    </button>
                    <button
                      onClick={handleClearFilters}
                      style={{
                        padding: "10px 18px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        color: "#64748b",
                        fontWeight: "700",
                        cursor: "pointer",
                        height: "42px",
                      }}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Table */}
            <div
              style={{
                overflowX: "auto",
                overflowY: "visible",
                borderRadius: "14px",
                border: "1.5px solid #e2e8f0",
              }}
            >
              <table
                style={{
                  width: "100%",
                  minWidth: "1200px",
                  borderCollapse: "collapse",
                  fontSize: "13px",
                }}
              >
                <thead>
                  <tr
                    style={{
                      background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                    }}
                  >
                    {[
                      "S.N",
                      "Name",
                      "Mobile",
                      "A/C Name",
                      "Bank",
                      "Branch",
                      "A/C Number",
                      "IFSC",
                      "Status",
                      "Date",
                      "Action",
                    ].map((th, i) => (
                      <th
                        key={i}
                        style={{
                          padding: "14px 12px",
                          color: "#ffffff",
                          fontWeight: "700",
                          fontSize: "11.5px",
                          textAlign: "left",
                          letterSpacing: "0.5px",
                          textTransform: "uppercase",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {th}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {visits.length > 0 ? (
                    visits.map((visit, index) => (
                      <tr
                        key={visit.id}
                        style={{ borderBottom: "1px solid #f1f5f9" }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#f8fafc")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "transparent")
                        }
                      >
                        <td style={cellBlue}>
                          {(currentPage - 1) * LIMIT + index + 1}
                        </td>
                        <td style={cellDark}>
                          {visit.username
                            ? visit.username.charAt(0).toUpperCase() +
                              visit.username.slice(1).toLowerCase()
                            : "-"}
                        </td>
                        <td style={cellGray}>{visit.mobile || "-"}</td>
                        <td style={cellDark}>
                          {visit.account_holder_name
                            ? visit.account_holder_name
                                .charAt(0)
                                .toUpperCase() +
                              visit.account_holder_name.slice(1).toLowerCase()
                            : "-"}
                        </td>
                        <td style={cellDark}>
                          {visit.bank_name
                            ? visit.bank_name.charAt(0).toUpperCase() +
                              visit.bank_name.slice(1).toLowerCase()
                            : "-"}
                        </td>
                        <td style={cellGray}>
                          {visit.bank_branch_name || "NA"}
                        </td>
                        <td style={cellGray}>{visit.account_number || "-"}</td>
                        <td style={cellGray}>{visit.ifsc_code || "-"}</td>
                        <td style={{ padding: "12px" }}>
                          <span
                            style={{
                              display: "inline-block",
                              padding: "4px 12px",
                              borderRadius: "20px",
                              fontSize: "11.5px",
                              fontWeight: "700",
                              background:
                                visit.status === "success"
                                  ? "#e7f9eb"
                                  : "#feeaeb",
                              color:
                                visit.status === "success"
                                  ? "#059669"
                                  : "#dc2626",
                              textTransform: "capitalize",
                            }}
                          >
                            {visit.status === "success" ? "✅ Success" : "⛔ Reject"}
                          </span>
                        </td>
                        <td style={{ ...cellGray, whiteSpace: "nowrap" }}>
                          {visit.created_at
                            ? new Date(visit.created_at)
                                .toLocaleDateString("en-GB")
                                .replace(/\//g, "-")
                            : "-"}
                        </td>
                        <td style={{ padding: "12px" }}>
                          {visit.status === "success" ? (
                            <button
                              onClick={() => handleEditClick(visit)}
                              style={{
                                padding: "7px 14px",
                                borderRadius: "8px",
                                border: "none",
                                background:
                                  "linear-gradient(135deg, #1e5799, #2b6cb0)",
                                color: "#ffffff",
                                fontSize: "12px",
                                fontWeight: "700",
                                cursor: "pointer",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                whiteSpace: "nowrap",
                                boxShadow:
                                  "0 4px 12px rgba(30, 87, 153, 0.25)",
                              }}
                            >
                              <FaEdit size={12} /> Edit
                            </button>
                          ) : (
                            <span
                              style={{
                                fontSize: "12px",
                                color: "#94a3b8",
                                fontWeight: "600",
                              }}
                            >
                              Not Allowed
                            </span>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="11"
                        style={{
                          padding: "50px",
                          textAlign: "center",
                          color: "#94a3b8",
                          fontWeight: "600",
                        }}
                      >
                        📭 No accounts found with status{" "}
                        {selectedStatus ? `"${selectedStatus}"` : ""}.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "24px",
                  gap: "6px",
                  flexWrap: "wrap",
                }}
              >
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  ‹ Prev
                </button>

                {getPageNumbers().map((p, i) => {
                  if (p === "left-ellipsis" || p === "right-ellipsis") {
                    return (
                      <span
                        key={`ellipsis-${i}`}
                        style={{
                          padding: "0 6px",
                          color: "#94a3b8",
                          fontWeight: "700",
                        }}
                      >
                        ...
                      </span>
                    );
                  }
                  const isActive = p === currentPage;
                  return (
                    <button
                      key={p}
                      onClick={() => handlePageChange(p)}
                      style={{
                        minWidth: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: isActive ? "none" : "1.5px solid #e2e8f0",
                        background: isActive
                          ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                          : "#ffffff",
                        color: isActive ? "#ffffff" : "#334155",
                        fontWeight: "700",
                        fontSize: "13px",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                          : "none",
                        transition: "all 0.18s ease",
                      }}
                    >
                      {p}
                    </button>
                  );
                })}

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: currentPage === totalPages ? "#cbd5e1" : "#1e5799",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor:
                      currentPage === totalPages ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  Next ›
                </button>
              </div>
            )}

            {totalItems > 0 && (
              <p
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  color: "#94a3b8",
                  marginTop: "12px",
                  marginBottom: 0,
                  fontWeight: "500",
                }}
              >
                Page {currentPage} of {totalPages} • {totalItems} total records
              </p>
            )}
          </div>
        </div>

        {/* Footer */}
        <p
          style={{
            textAlign: "center",
            color: "#94a3b8",
            fontSize: "12.5px",
            marginTop: "24px",
            fontWeight: "500",
          }}
        >
          © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All Rights
          Reserved.
        </p>
      </div>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 EDIT MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        centered
        backdrop="static"
        size="lg"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#1e5799",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            ✏️ Update Bank Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ padding: "24px", maxHeight: "70vh", overflowY: "auto" }}
        >
          {editingVisit && (
            <Form>
              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label style={labelStyle}>
                      Account Holder Name
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="account_holder_name"
                      value={editFormData.account_holder_name}
                      onChange={handleEditFormChange}
                      style={inputStyle}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label style={labelStyle}>Bank Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="bank_name"
                      value={editFormData.bank_name}
                      onChange={handleEditFormChange}
                      style={inputStyle}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label style={labelStyle}>Account Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="account_number"
                      value={editFormData.account_number}
                      onChange={handleEditFormChange}
                      style={inputStyle}
                    />
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label style={labelStyle}>IFSC Code</Form.Label>
                    <Form.Control
                      type="text"
                      name="ifsc_code"
                      value={editFormData.ifsc_code}
                      onChange={handleEditFormChange}
                      style={inputStyle}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label style={labelStyle}>Branch Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="bank_branch_name"
                      value={editFormData.bank_branch_name}
                      onChange={handleEditFormChange}
                      style={inputStyle}
                    />
                  </Form.Group>
                </div>
              </div>
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer
          style={{
            borderTop: "1.5px solid #e2e8f0",
            padding: "16px 24px",
            gap: "10px",
          }}
        >
          <button
            type="button"
            onClick={() => setShowEditModal(false)}
            style={{
              padding: "10px 22px",
              borderRadius: "10px",
              border: "1.5px solid #e2e8f0",
              background: "#ffffff",
              color: "#64748b",
              fontSize: "13px",
              fontWeight: "700",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleUpdate}
            disabled={updating}
            style={{
              padding: "10px 22px",
              borderRadius: "10px",
              border: "none",
              background: updating
                ? "#cbd5e1"
                : "linear-gradient(135deg, #1e5799, #2b6cb0)",
              color: "#ffffff",
              fontSize: "13px",
              fontWeight: "700",
              cursor: updating ? "not-allowed" : "pointer",
              boxShadow: updating
                ? "none"
                : "0 4px 12px rgba(30, 87, 153, 0.3)",
            }}
          >
            {updating ? "Updating..." : "Update"}
          </button>
        </Modal.Footer>
      </Modal>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

// ═══════════════════════════════════════════
// 🎨 SHARED STYLES
// ═══════════════════════════════════════════
const labelStyle = {
  display: "block",
  fontSize: "12.5px",
  fontWeight: "700",
  color: "#1e3a5f",
  marginBottom: "6px",
};

const inputStyle = {
  width: "100%",
  padding: "10px 14px",
  borderRadius: "10px",
  border: "1.5px solid #e2e8f0",
  fontSize: "13.5px",
  fontWeight: "500",
  color: "#1e3a5f",
  outline: "none",
  boxSizing: "border-box",
};

const cellBlue = { padding: "12px", fontWeight: "700", color: "#1e5799" };
const cellDark = { padding: "12px", fontWeight: "600", color: "#1e3a5f" };
const cellGray = { padding: "12px", color: "#64748b" };

export default AccountStatusList;